module.exports = __webpack_public_path__ + "assets/images/pages/kfc/kfc-2.png?ee4e45c3";